import React, { useState, useEffect, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './operators.css'

import {
  FormControl,
  TextField, Autocomplete, Grid, IconButton, Typography, Tooltip,
  Switch, FormControlLabel, Box, InputAdornment, Dialog, DialogTitle, DialogContent,
  DialogActions, Button, Select, MenuItem, InputLabel, Fade
} from '@mui/material';
import { Edit, Search, PersonAdd, Email, Lock, Group, Person, FilterAltOffSharp, FilterAltSharp, Logout } from '@mui/icons-material';
import { getServiceGroups } from '../../redux/serviceGroup/serviceGroup.actions';
import { getProfiles } from '../../redux/profile/profile.actions';
import TableInfo from '../../components/TableInfo';
import { logOut, updateUser, createUser, getUsers, updateUserPresence } from '../../redux/user/user.actions';
import CadastroDoRepresentante from '../../components/CadastroDoRepresentante';
import MarcasQueAtende, { useMarcasDisponiveis, idsDasMarcasDoOperador } from '../../components/MarcasQueAtende';
import { fetchTickets } from '../../redux/ticket/ticket.actions';
import { ThemeContext } from '../../components/ThemeContext/ThemeContext';
import { toast } from 'react-toastify';
import FilterSlidePanel from '../../components/FilterSlidePanel';
import http from '../../services/http';
import { hasAdminProfile } from '../../utils/profileRole';

const OperatorsPage = props => {
  const canEditRamal = (props.permissions || []).includes('#editar-ramal-usuario');
  // As marcas do tenant (SysFar, MAX), buscadas uma vez por sessão. Alimentam
  // os dois modais -- criar e editar operador.
  const marcasDisponiveis = useMarcasDisponiveis();
  const [name, setName] = useState(null);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [email, setEmail] = useState('');
  const [services, setServices] = useState([])
  const [serviceInput, setServiceInput] = useState('')
  const [serviceGroupId, setServiceGroupId] = useState(null)
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const [selectedServiceGroup, setSelectedServiceGroup] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('all');

  // Estados para o modal de criação
  const [openModal, setOpenModal] = useState(false);
  const [modalFormData, setModalFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    serviceGroup: null,
    profile: null,
    ramal: '',
    // Cadastro do representante. Os mesmos nomes de campo que a api espera,
    // para o payload ser um espalhamento e nao uma traducao -- traducao e
    // onde se esquece um campo.
    representante_codigo: '',
    representante_company_id: null,
    responsavel_id: null,
    telefone: '',
    // As marcas que ele atende (Gisele, 19/10). Lista vazia é "atende todas",
    // que é o padrão certo para um cadastro novo.
    whatsapp_number_ids: []
  });
  const [modalErrors, setModalErrors] = useState({
    name: false,
    email: false,
    password: false,
    confirmPassword: false,
    serviceGroup: false,
    profile: false
  });

  // Estados para o modal de edição
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editModalOperator, setEditModalOperator] = useState(null);
  // Reset de senha do operador (item 11): admin define nova senha (e-mail bloqueado).
  const [resetOpen, setResetOpen] = useState(false);
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [resetting, setResetting] = useState(false);
  const [editFormData, setEditFormData] = useState({
    name: '',
    email: '',
    CRMId: '',
    serviceGroup: '',
    profileId: '',
    ramal: '',
    orbyOnly: false,
    representante_codigo: '',
    representante_company_id: null,
    responsavel_id: null,
    telefone: '',
    // As marcas que ele atende (Gisele, 19/10). Lista vazia é "atende todas".
    whatsapp_number_ids: []
  });
  const [editModalErrors, setEditModalErrors] = useState({
    name: false,
    serviceGroup: false,
    profileId: false
  });

  const { theme } = useContext(ThemeContext);
  const { permissions, currentUser } = props;

  const isPresenceAdmin =
    hasAdminProfile(currentUser) || Boolean(currentUser?.is_super_admin);

  useEffect(() => {
    props.getUsers({ includeInactive: true });
    props.getServiceGroups();
    props.getProfiles();

    if (props.serviceGroups.length > 0) {
      setServiceGroupId(props.serviceGroups[0].id);
    }
    return () => {
      props.getUsers();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createRows = useCallback(() => {
    const newServices = props.serviceGroups.map(service => ({ value: service.id, label: service.description }));
    setServices(newServices);

    if (props.users) {
      const newRows = props.users.map((user) => {
        return {
          id: user.id,
          name: user ? user.name : name,
          serviceGroupId: user.service_group_id,
          serviceGroupName: user.service_group ? user.service_group.description : '',
          profileId: user.profile_id,
          email: user.email,
          status: user.status,
          CRM_id: user.CRM_id,
          ramal: user.ramal ?? '',
          orby_only: !!user.orby_only,
          // Cadastro do representante. Tem de vir para a linha: o modal de
          // edicao se preenche a partir DELA, e um campo ausente aqui abriria
          // o modal em branco e GRAVARIA em branco no primeiro salvamento --
          // apagando a carteira de alguem sem ninguem tocar no campo.
          representante_codigo: user.representante_codigo ?? '',
          representante_company_id: user.representante_company_id ?? null,
          responsavel_id: user.responsavel_id ?? null,
          telefone: user.telefone ?? '',
          // As marcas que ele atende (Gisele, 19/10). Pela MESMA razão escrita
          // acima sobre o representante: o modal de edição se preenche desta
          // linha, e sem o campo aqui ele abriria com tudo desmarcado e
          // gravaria "atende todas" no primeiro salvamento -- desconfigurando
          // as filas de quem já estava configurado, sem ninguém tocar no campo.
          whatsapp_number_ids: idsDasMarcasDoOperador(user),
          // picture: user.picture,
        }
      }).filter(row => row !== null);
      setRows(newRows);
      setFilteredRows(newRows);
    }

  }, [props.users, props.serviceGroups, name]);

  useEffect(() => {
    createRows();

    if (serviceGroupId && props.serviceGroups.length > 0) {
      const selectedService = props.serviceGroups.find(service => service.id === serviceGroupId);
      setServiceInput(selectedService ? selectedService.description : '');
    }
    // eslint-disable-next-line
  }, [props.users, props.serviceGroups, serviceGroupId, createRows]);

  // Listener para evento customizado do FAB global
  useEffect(() => {
    const handleOpenOperatorModal = () => {
      handleNewOperator();
    };

    window.addEventListener('openOperatorModal', handleOpenOperatorModal);
    return () => {
      window.removeEventListener('openOperatorModal', handleOpenOperatorModal);
    };
  }, []);

  const handleNewOperator = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalFormData({
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
      serviceGroup: null,
      profile: null,
      ramal: '',
      // Volta a lista vazia ("atende todas") ao fechar: sem isto, abrir o
      // cadastro de novo traria marcadas as marcas do cadastro anterior.
      whatsapp_number_ids: []
    });
    setModalErrors({
      name: false,
      email: false,
      password: false,
      confirmPassword: false,
      serviceGroup: false,
      profile: false
    });
  };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleModalInputChange = (field, value) => {
    setModalFormData(prev => ({ ...prev, [field]: value }));

    // Limpar erro quando usuário começar a digitar
    if (modalErrors[field]) {
      setModalErrors(prev => ({ ...prev, [field]: false }));
    }
  };

  const handleCreateOperator = async () => {
    const { name, email, password, confirmPassword, serviceGroup, profile, ramal,
      representante_codigo: representanteCodigo, representante_company_id: representanteCompanyId,
      responsavel_id: responsavelId, telefone,
      whatsapp_number_ids: marcasQueAtende } = modalFormData;

    // Validações
    const isNameValid = name.trim() !== '';
    const isEmailValid = email.trim() !== '' && validateEmail(email);
    const isPasswordValid = password.trim() !== '' && password.length >= 6;
    const isConfirmPasswordValid = confirmPassword.trim() !== '' && confirmPassword === password;
    const isServiceGroupValid = serviceGroup !== null;
    const isProfileValid = profile !== null;

    const newErrors = {
      name: !isNameValid,
      email: !isEmailValid,
      password: !isPasswordValid,
      confirmPassword: !isConfirmPasswordValid,
      serviceGroup: !isServiceGroupValid,
      profile: !isProfileValid
    };

    setModalErrors(newErrors);

    if (!isNameValid || !isEmailValid || !isPasswordValid || !isConfirmPasswordValid || !isServiceGroupValid || !isProfileValid) {
      return;
    }

    try {
      await props.createUser({
        service_group_id: serviceGroup,
        name: name,
        password: password,
        profile_id: profile,
        email: email,
        status: 1,
        ...(canEditRamal ? { ramal } : {}),
        representante_codigo: representanteCodigo,
        representante_company_id: representanteCompanyId || null,
        responsavel_id: responsavelId || null,
        telefone,
        whatsapp_number_ids: Array.isArray(marcasQueAtende) ? marcasQueAtende : [],
      });

      toast.success('Operador criado com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
        style: {
          backgroundColor: theme.palette.background.toast,
          color: theme.palette.success.contrastText,
        },
      });

      handleCloseModal();
    } catch (error) {
      console.error('Erro ao criar operador:', error);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);

    // Limpar timeout anterior
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Criar novo timeout para debounce
    const newTimeout = setTimeout(() => {
      if (value.trim() === '') {
        setFilteredRows(rows);
      } else {
        const filtered = rows.filter(row =>
          row.name.toLowerCase().includes(value.toLowerCase()) ||
          row.email.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredRows(filtered);
      }
    }, 300); // 300ms de debounce

    setSearchTimeout(newTimeout);
  };

  const handleOpenFilterPanel = () => setFilterPanelOpen(true);
  const handleCloseFilterPanel = () => setFilterPanelOpen(false);

  const handleApplyFilters = () => {
    let filtered = rows;

    // Filtrar por grupo de serviço
    if (selectedServiceGroup) {
      filtered = filtered.filter(row => 
        row.serviceGroupId === selectedServiceGroup.id
      );
    }

    // Filtrar por status
    if (selectedStatus !== 'all') {
      filtered = filtered.filter(row => row.status === selectedStatus);
    }

    // Aplicar busca de texto se houver
    if (searchTerm.trim() !== '') {
      filtered = filtered.filter(row =>
        row.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredRows(filtered);
    setFilterPanelOpen(false);
  };

  const handleClearFilters = () => {
    setSelectedServiceGroup(null);
    setSelectedStatus('all');
    setFilteredRows(rows);
  };

  const handleUpdateOperator = (row) => {
    setEditModalOperator(row);
    setEditFormData({
      name: row.name || '',
      email: row.email || '',
      CRMId: row.CRM_id ?? '',
      serviceGroup: row.serviceGroupId ?? '',
      profileId: row.profileId ?? '',
      ramal: row.ramal ?? '',
      orbyOnly: !!row.orby_only,
      representante_codigo: row.representante_codigo ?? '',
      representante_company_id: row.representante_company_id ?? null,
      responsavel_id: row.responsavel_id ?? null,
      telefone: row.telefone ?? '',
      whatsapp_number_ids: Array.isArray(row.whatsapp_number_ids) ? row.whatsapp_number_ids : []
    });
    setEditModalErrors({ name: false, serviceGroup: false, profileId: false });
    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setEditModalOperator(null);
    setEditFormData({
      name: '', email: '', CRMId: '', serviceGroup: '', profileId: '', ramal: '', orbyOnly: false,
      representante_codigo: '', representante_company_id: null, responsavel_id: null, telefone: '',
      whatsapp_number_ids: []
    });
    setEditModalErrors({ name: false, serviceGroup: false, profileId: false });
  };

  const handleEditModalInputChange = (field, value) => {
    setEditFormData(prev => ({ ...prev, [field]: value }));
    if (editModalErrors[field]) {
      setEditModalErrors(prev => ({ ...prev, [field]: false }));
    }
  };

  const [desconectando, setDesconectando] = useState(false);

  // Derruba as sessões abertas do operador, em todos os dispositivos.
  //
  // Não é o mesmo que desativar: quem está ativo pode entrar de novo em
  // seguida. Serve para o caso de alguém ter esquecido a sessão aberta em
  // outra máquina. Para tirar o acesso, o operador precisa ficar Inativo --
  // e inativar já desconecta por baixo.
  const handleDesconectar = async () => {
    if (!editModalOperator?.id) return;

    const nome = editFormData.name || editModalOperator.name || 'este operador';

    if (!window.confirm(`Encerrar as sessões de ${nome}? A pessoa será deslogada em todos os dispositivos.`)) {
      return;
    }

    setDesconectando(true);
    try {
      await http.post(`/users/${editModalOperator.id}/desconectar`);
      toast.success(`Sessões de ${nome} encerradas.`, { position: toast.POSITION.BOTTOM_CENTER });
    } catch (e) {
      const msg = e?.response?.data?.message || e?.responseData?.message || 'Não foi possível encerrar as sessões.';
      toast.error(msg, { position: toast.POSITION.BOTTOM_CENTER });
    } finally {
      setDesconectando(false);
    }
  };

  const openResetPassword = () => {
    setNewPass('');
    setConfirmPass('');
    setResetOpen(true);
  };

  const handleResetPassword = async () => {
    if (!editModalOperator?.id) return;
    if (!newPass || newPass.length < 6) {
      toast.error('A nova senha deve ter ao menos 6 caracteres.', { position: toast.POSITION.BOTTOM_CENTER });
      return;
    }
    if (newPass !== confirmPass) {
      toast.error('As senhas não conferem.', { position: toast.POSITION.BOTTOM_CENTER });
      return;
    }
    setResetting(true);
    try {
      await http.post(`/users/${editModalOperator.id}/reset-password`, {
        password: newPass,
        password_confirmation: confirmPass,
      });
      toast.success(`Senha de ${editFormData.name || editModalOperator.name || 'operador'} redefinida com sucesso!`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setResetOpen(false);
      setNewPass('');
      setConfirmPass('');
    } catch (e) {
      const msg = e?.response?.data?.message || 'Não foi possível redefinir a senha.';
      toast.error(msg, { position: toast.POSITION.BOTTOM_CENTER });
    } finally {
      setResetting(false);
    }
  };

  const handleSaveEditOperator = async () => {
    const { name, email, CRMId, serviceGroup, profileId, ramal, orbyOnly,
      representante_codigo: representanteCodigo, representante_company_id: representanteCompanyId,
      responsavel_id: responsavelId, telefone,
      whatsapp_number_ids: marcasQueAtende } = editFormData;
    const isNameValid = name.trim() !== '';
    const isServiceGroupValid = serviceGroup !== '' && serviceGroup != null;
    const isProfileIdValid = profileId !== '' && profileId != null;

    const newErrors = {
      name: !isNameValid,
      serviceGroup: !isServiceGroupValid,
      profileId: !isProfileIdValid
    };
    setEditModalErrors(newErrors);

    if (!isNameValid || !isServiceGroupValid || !isProfileIdValid) return;

    try {
      await props.updateUser({
        id: editModalOperator.id,
        name: name.trim(),
        email: email.trim(),
        picture: editModalOperator.picture,
        profile_id: profileId,
        service_group_id: serviceGroup,
        status: editModalOperator.status,
        CRM_id: CRMId || undefined,
        orby_only: !!orbyOnly,
        ...(canEditRamal ? { ramal } : {}),
        representante_codigo: representanteCodigo,
        representante_company_id: representanteCompanyId || null,
        responsavel_id: responsavelId || null,
        telefone,
        // As marcas que ele atende (Gisele, 19/10). Sempre no payload: a api
        // só mexe na configuração quando a chave vem, e esta tela é justamente
        // a que a edita -- omiti-la aqui tornaria impossível DESMARCAR tudo.
        whatsapp_number_ids: Array.isArray(marcasQueAtende) ? marcasQueAtende : [],
      });

      // Atualização otimista: reflete a alteração na tabela na hora
      const serviceGroupName = props.serviceGroups.find(sg => sg.id === Number(serviceGroup))?.description ?? editModalOperator.serviceGroupName;
      // As duas listas recebem os campos novos. Atualizar so uma deixaria a
      // tabela e o filtro discordando -- e o modal, que le da linha, reabriria
      // com o valor velho.
      const camposDoRepresentante = {
        representante_codigo: representanteCodigo,
        representante_company_id: representanteCompanyId || null,
        responsavel_id: responsavelId || null,
        telefone,
        // Junto, pela mesma razão: o modal relê da linha, e sem isto reabriria
        // com as marcas antigas até a próxima carga da lista.
        whatsapp_number_ids: Array.isArray(marcasQueAtende) ? marcasQueAtende : [],
      };
      setRows(prev => prev.map(r => r.id === editModalOperator.id
        ? { ...r, name: name.trim(), email: email.trim(), CRM_id: CRMId || undefined, serviceGroupId: serviceGroup, serviceGroupName, profileId, ramal: canEditRamal ? ramal : r.ramal, orby_only: !!orbyOnly, ...camposDoRepresentante }
        : r
      ));
      setFilteredRows(prev => prev.map(r => r.id === editModalOperator.id
        ? { ...r, name: name.trim(), email: email.trim(), CRM_id: CRMId || undefined, serviceGroupId: serviceGroup, serviceGroupName, profileId, ramal: canEditRamal ? ramal : r.ramal, orby_only: !!orbyOnly, ...camposDoRepresentante }
        : r
      ));

      // Garante que o Redux também tenha a lista atualizada
      await props.getUsers({ includeInactive: true });

      toast.success(`Operador ${name} atualizado com sucesso!`, {
        position: toast.POSITION.BOTTOM_CENTER,
        style: {
          backgroundColor: theme.palette.background.toast,
          color: theme.palette.success.contrastText,
        },
      });

      handleCloseEditModal();
    } catch (error) {
      console.error('Erro ao atualizar operador:', error);
    }
  };

  const setServiceGroupRow = () => (
    <FormControl fullWidth>
      <Autocomplete
        noOptionsText="Nenhuma opção"
        value={services.find(service => service.value === serviceGroupId) || null}
        inputValue={serviceInput}
        onInputChange={(event, newInputValue) => {
          if (event !== null) {
            setServiceInput(newInputValue)
          }
        }}
        options={services}
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setServiceGroupId(newValue.value);
            setServiceInput(newValue.label);
          } else {
            setServiceGroupId(null);
            setServiceInput('');
          }
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </FormControl>
  )

  const handleUpdateOperatorInLine = async (params, e) => {
    if (e.key === 'Escape') {
      setName('');
      setServiceInput('');
      setServiceGroupId(null);
      setEmail('');
      return
    }
    if (serviceGroupId || name || email) {
      await props.updateUser({
        id: params.id,
        name: name ? name : params.row.name,
        email: email ? email : params.row.email,
        picture: params.row.picture,
        service_group_id: serviceGroupId || params.row.serviceGroupId,
        status: params.row.status,
      });
      setName('');
      setServiceInput('');
      setServiceGroupId(null);
      setEmail('');
    }
  };

  const [clickTimeout, setClickTimeout] = useState(null);

  const handleCellClick = (params, event) => {
    if (params.field === 'status' || params.field === 'presence' || params.field === 'action')
      return;
    // Se já houver um clique registrado, limpe o timeout e considere isso como um duplo clique
    // (a edição da célula será tratada pelo DataGrid automaticamente)
    if (clickTimeout !== null) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
      return;
    }

    // Registra o primeiro clique e define um timeout
    // Se não houver um segundo clique dentro do intervalo, executa a ação do clique simples
    const newTimeout = setTimeout(() => {
      // Redireciona para a página de edição
      handleUpdateOperator(params.row);
      setClickTimeout(null);
    }, 250); // 250ms para o segundo clique

    setClickTimeout(newTimeout);
  };



  const columns = [
    {
      field: 'name',
      headerName: 'Nome',
      headerClassName: 'table-sort-header compact',
      flex: 1,
      editable: true,
      align: 'left',
      headerAlign: 'center',
      preProcessEditCellProps: (params) => setName(params.props.value)
    },
    {
      field: 'email',
      headerName: 'E-mail',
      headerClassName: 'table-sort-header compact',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      // O DataGrid não tem tipo "email" -- ele avisava no console e caía para
      // "string", que é o padrão. Nada muda tirando a linha.
      editable: true,
      preProcessEditCellProps: (params) => setEmail(params.props.value)
    },
    {
      field: 'serviceGroupId',
      headerName: 'Grupo de Atendimento',
      headerClassName: 'table-sort-header compact',
      flex: 1,
      editable: true,
      type: 'number',
      align: 'center',
      headerAlign: 'center',
      renderEditCell: params => setServiceGroupRow(params),
      valueGetter: params => params.row.serviceGroupName,
    },
    {
      field: 'action',
      /*
       * SEM `type: 'actions'`, e isto tem consequência de teclado.
       *
       * `type: 'actions'` é o tipo em que o DataGrid espera `getActions`
       * devolvendo `GridActionsCellItem` -- e ele faz duas coisas por conta
       * disso: injeta um `focusElementRef` no filho (que aqui é um `Tooltip`,
       * que o repassa até o `<button>` do DOM, e o React avisava
       * "React does not recognize the focusElementRef prop") e põe
       * `tabIndex: -1` na célula, delegando o foco para a célula de ações que
       * esta coluna não usa. Resultado: o botão de editar não era alcançável
       * pelo teclado.
       *
       * As três props abaixo repõem o que o tipo dava de útil.
       */
      headerName: 'Ações',
      headerClassName: 'table-sort-header compact',
      flex: 0.5,
      align: 'right',
      sortable: false,
      filterable: false,
      disableExport: true,
      // Estava devolvendo uma LISTA de um elemento só, e lista pede `key`:
      // era isso o "Each child in a list should have a unique key" que
      // aparecia na tela de operadores. Um elemento sozinho não é lista.
      renderCell: (params) => (
        <Tooltip title="Editar">
          <IconButton onClick={() => handleUpdateOperator(params.row)} label="Editar" sx={{
            '&:hover': {
              backgroundColor: theme.palette.background.hover,
            }
          }}>
            <Edit />
          </IconButton>
        </Tooltip>
      )
    },
    {
      field: 'presence',
      headerName: 'Presença',
      headerClassName: 'table-sort-header compact',
      flex: 0.35,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => {
        const selfId = currentUser?.id ?? JSON.parse(localStorage.getItem('user') || '{}').id;
        if (Number(params.row.id) === Number(selfId)) return '';
        if (params.row.status === 4) {
          return (
            <Typography variant="caption" color="text.secondary">—</Typography>
          );
        }
        if (!isPresenceAdmin) return '';
        const online = params.row.status === 1 || params.row.status === 2;
        return (
          <Tooltip title={online ? 'Ativo — clique para ficar inativo' : 'Inativo — clique para ficar ativo'}>
            <Switch
              size="small"
              checked={online}
              onChange={() => {
                const next = online ? 3 : 1;
                props.updateUserPresence(params.row.id, next);
              }}
            />
          </Tooltip>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      description: 'Operador não terá acesso ao sistema',
      headerClassName: 'table-sort-header compact',
      flex: 0.3,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params.row.id === JSON.parse(localStorage.user).id ? ''
          : <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
              {params.row.status === 4 ? 'Inativo' : 'Ativo'}
            </Typography>
            <Switch
              checked={params.row.status !== 4}
              onChange={() => handleToggleOperatorStatus(params.row.id, params.row.status)}
              disabled={!permissions.includes('#inactivate-operator')}
            />
          </Box>
      )
    },
  ]

  const handleToggleOperatorStatus = async (operatorId, currentStatus) => {
    if (permissions.includes('#inactivate-operator')) {
      const newStatus = currentStatus === 4 ? 1 : 4;
      await props.updateUser({ id: operatorId, status: newStatus });
      if (newStatus === 4) {
        props.fetchTickets();
      }
    } else {
      alert("Você não tem permissão para realizar esta ação.");
    }
  };

  return (
    /* `md={12}` é prop de item, não de container -- mesmo caso do `TableInfo`:
       o estilo que ele gerava está escrito abaixo para a tela não mudar. */
    <Grid
      container
      flexDirection={'column'}
      className='operators-page'
      sx={{
        flexBasis: '100%',
        flexGrow: 0,
        maxWidth: '100%',
        backgroundColor: 'var(--blue-700) !important',
      }}
    >
      <Grid item className='table-all' sx={{ position: 'relative' }}>
        <Box sx={{ 
          padding: 2, 
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          gap: 2,
          alignItems: 'center'
        }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Pesquisar operadores por nome ou e-mail..."
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            sx={{ maxWidth: 400 }}
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={(selectedServiceGroup || selectedStatus !== 'all') ? <FilterAltSharp /> : <FilterAltOffSharp />}
            onClick={handleOpenFilterPanel}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              px: 3
            }}
          >
            Configurar Filtros
          </Button>
        </Box>
        <TableInfo
          // color={'var(--blue-900)'}
          rows={filteredRows}
          columns={columns}
          autoHeight={false}
          fullHeight={true}
          color={theme.palette.background.default}
          onCellEditStart={(params) => {
            setServiceGroupId(params.row.serviceGroupId)
            setServiceInput(params.row.serviceGroupName)
          }}
          onCellEditStop={handleUpdateOperatorInLine}
          onCellClick={handleCellClick}
        />

        {/* Modal de Criação de Operador */}
        <Dialog
          open={openModal}
          onClose={handleCloseModal}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
              margin: 3,
              maxHeight: 'calc(100vh - 48px)',
            }
          }}
        >
          <DialogTitle sx={{
            textAlign: 'center',
            pb: 2,
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            position: 'relative',
            borderBottom: '1px solid',
            borderColor: 'divider'
          }}>
            <Box sx={{
              display: 'inline-flex',
              p: 1.5,
              borderRadius: '50%',
              backgroundColor: theme.palette.primary.main,
              mb: 2
            }}>
              <PersonAdd sx={{ fontSize: 28, color: 'white' }} />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
              Criar Novo Operador
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              Preencha os dados abaixo para criar um novo operador
            </Typography>
          </DialogTitle>

          <DialogContent sx={{ 
            p: 4, 
            pt: 4,
            bgcolor: theme.palette.background.default 
          }}>
            <Fade in={openModal} timeout={300}>
              <Box sx={{ px: 2, py: 1 }}>
                <Grid container spacing={3}>
                  {/* Nome */}
                  <Grid item xs={12}>
                    <TextField
                      label="Nome Completo"
                      value={modalFormData.name}
                      onChange={({ target }) => handleModalInputChange('name', target.value)}
                      required
                      variant='outlined'
                      fullWidth
                      error={modalErrors.name}
                      helperText={modalErrors.name ? "O nome é obrigatório" : ""}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        }
                      }}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12}>
                    <TextField
                      label="E-mail"
                      value={modalFormData.email}
                      onChange={({ target }) => handleModalInputChange('email', target.value)}
                      required
                      type='email'
                      variant='outlined'
                      fullWidth
                      error={modalErrors.email}
                      helperText={modalErrors.email ? "E-mail inválido ou obrigatório" : ""}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Email color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        }
                      }}
                    />
                  </Grid>

                  {/* Senha */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Senha"
                      value={modalFormData.password}
                      onChange={({ target }) => handleModalInputChange('password', target.value)}
                      required
                      type='password'
                      variant='outlined'
                      fullWidth
                      error={modalErrors.password}
                      helperText={modalErrors.password ? "A senha deve ter pelo menos 6 caracteres" : ""}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        }
                      }}
                    />
                  </Grid>

                  {/* Confirmar Senha */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Confirmar Senha"
                      value={modalFormData.confirmPassword}
                      onChange={({ target }) => handleModalInputChange('confirmPassword', target.value)}
                      required
                      type='password'
                      variant='outlined'
                      fullWidth
                      error={modalErrors.confirmPassword}
                      helperText={modalErrors.confirmPassword ? "As senhas não coincidem" : ""}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                        }
                      }}
                    />
                  </Grid>

                  {/* Grupo de Atendimento */}
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={modalErrors.serviceGroup} sx={{ minWidth: 120 }}>
                      <InputLabel>Grupo de Atendimento</InputLabel>
                      <Select
                        value={modalFormData.serviceGroup || ''}
                        onChange={({ target }) => handleModalInputChange('serviceGroup', target.value)}
                        label="Grupo de Atendimento"
                        variant='outlined'
                        startAdornment={
                          <InputAdornment position="start">
                            <Group color="action" />
                          </InputAdornment>
                        }
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          }
                        }}
                      >
                        {props.serviceGroups.map(group =>
                          <MenuItem key={group.id} value={group.id}>
                            {group.description}
                          </MenuItem>
                        )}
                      </Select>
                      {modalErrors.serviceGroup && (
                        <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                          Este campo é obrigatório.
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                  {/* Perfil */}
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={modalErrors.profile} sx={{ minWidth: 120 }}>
                      <InputLabel>Perfil</InputLabel>
                      <Select
                        value={modalFormData.profile || ''}
                        onChange={({ target }) => handleModalInputChange('profile', target.value)}
                        label="Perfil"
                        variant='outlined'
                        startAdornment={
                          <InputAdornment position="start">
                            <Person color="action" />
                          </InputAdornment>
                        }
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                          }
                        }}
                      >
                        {props.profiles?.profiles?.map(profile =>
                          <MenuItem key={profile.id} value={profile.id}>
                            {profile.name}
                          </MenuItem>
                        )}
                      </Select>
                      {modalErrors.profile && (
                        <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                          Este campo é obrigatório.
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Ramal (URA)"
                      value={modalFormData.ramal}
                      onChange={({ target }) => handleModalInputChange('ramal', target.value.replace(/\D+/g, ''))}
                      variant="outlined"
                      fullWidth
                      disabled={!canEditRamal}
                      inputProps={{ inputMode: 'numeric' }}
                      helperText={canEditRamal
                        ? 'Somente números (ex.: 6713). Usado para atribuir tickets da URA ao operador.'
                        : 'Somente leitura — requer a permissão "Editar o ramal (URA) dos usuários".'}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <CadastroDoRepresentante
                      valores={modalFormData}
                      aoMudar={handleModalInputChange}
                      operadores={rows}
                    />
                    <MarcasQueAtende
                      marcas={marcasDisponiveis}
                      selecionadas={modalFormData.whatsapp_number_ids}
                      aoMudar={(ids) => handleModalInputChange('whatsapp_number_ids', ids)}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Fade>
          </DialogContent>

          <DialogActions sx={{ 
            p: 3, 
            pt: 2,
            px: 6,
            borderTop: '1px solid',
            borderColor: 'divider',
            gap: 2
          }}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              sx={{
                borderRadius: 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleCreateOperator}
              sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 4px 14px 0 rgba(0, 118, 255, 0.39)',
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark,
                  boxShadow: '0 6px 20px 0 rgba(0, 118, 255, 0.49)',
                }
              }}
            >
              Criar Operador
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Edição de Operador */}
        <Dialog
          open={openEditModal}
          onClose={handleCloseEditModal}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
              margin: 3,
              maxHeight: 'calc(100vh - 48px)',
            }
          }}
        >
          <DialogTitle sx={{
            textAlign: 'center',
            pb: 2,
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            position: 'relative',
            borderBottom: '1px solid',
            borderColor: 'divider'
          }}>
            <Box sx={{
              display: 'inline-flex',
              p: 1.5,
              borderRadius: '50%',
              backgroundColor: theme.palette.primary.main,
              mb: 2
            }}>
              <Edit sx={{ fontSize: 28, color: 'white' }} />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
              Alterar Operador
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              Edite os dados do operador
            </Typography>
          </DialogTitle>

          <DialogContent sx={{
            p: 4,
            pt: 4,
            bgcolor: theme.palette.background.default
          }}>
            <Fade in={openEditModal} timeout={300}>
              <Box sx={{ px: 2, py: 1 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      label="Nome Completo"
                      value={editFormData.name}
                      onChange={({ target }) => handleEditModalInputChange('name', target.value)}
                      required
                      variant="outlined"
                      fullWidth
                      error={editModalErrors.name}
                      helperText={editModalErrors.name ? 'O nome é obrigatório' : ''}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="E-mail"
                      value={editFormData.email}
                      onChange={({ target }) => handleEditModalInputChange('email', target.value)}
                      type="email"
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Email color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Código Movidesk"
                      value={editFormData.CRMId}
                      onChange={({ target }) => handleEditModalInputChange('CRMId', target.value)}
                      variant="outlined"
                      fullWidth
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Ramal (URA)"
                      value={editFormData.ramal}
                      onChange={({ target }) => handleEditModalInputChange('ramal', target.value.replace(/\D+/g, ''))}
                      variant="outlined"
                      fullWidth
                      disabled={!canEditRamal}
                      inputProps={{ inputMode: 'numeric' }}
                      helperText={canEditRamal
                        ? 'Somente números (ex.: 6713). Usado para atribuir tickets da URA ao operador.'
                        : 'Somente leitura — requer a permissão "Editar o ramal (URA) dos usuários".'}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={editModalErrors.serviceGroup} sx={{ minWidth: 120 }}>
                      <InputLabel>Grupo de Atendimento</InputLabel>
                      <Select
                        value={editFormData.serviceGroup ?? ''}
                        onChange={({ target }) => handleEditModalInputChange('serviceGroup', target.value)}
                        label="Grupo de Atendimento"
                        variant="outlined"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      >
                        {props.serviceGroups.map((group) => (
                          <MenuItem key={group.id} value={group.id}>
                            {group.description}
                          </MenuItem>
                        ))}
                      </Select>
                      {editModalErrors.serviceGroup && (
                        <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                          Este campo é obrigatório.
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={editModalErrors.profileId} sx={{ minWidth: 120 }}>
                      <InputLabel>Perfil</InputLabel>
                      <Select
                        value={editFormData.profileId ?? ''}
                        onChange={({ target }) => handleEditModalInputChange('profileId', target.value)}
                        label="Perfil"
                        variant="outlined"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                      >
                        {props.profiles?.profiles?.map((profile) => (
                          <MenuItem key={profile.id} value={profile.id}>
                            {profile.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {editModalErrors.profileId && (
                        <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                          Este campo é obrigatório.
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!!editFormData.orbyOnly}
                          onChange={({ target }) => handleEditModalInputChange('orbyOnly', target.checked)}
                        />
                      }
                      label="Acesso somente Orby (não acessa o AloDesk)"
                    />
                    <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', ml: 0.5 }}>
                      Quando ligado, este operador entra apenas no chat do Orby (link /orby) e não enxerga a plataforma.
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <CadastroDoRepresentante
                      valores={editFormData}
                      aoMudar={handleEditModalInputChange}
                      operadores={rows}
                      idDoProprio={editModalOperator ? editModalOperator.id : null}
                    />
                    {/*
                      As marcas que ele atende (Gisele, 19/10). Fica no cadastro
                      do OPERADOR, e não dentro do departamento: "não se priva
                      somente ao suporte" -- a mesma pessoa pode ser de qualquer
                      departamento e atender uma marca só.
                    */}
                    <MarcasQueAtende
                      marcas={marcasDisponiveis}
                      selecionadas={editFormData.whatsapp_number_ids}
                      aoMudar={(ids) => handleEditModalInputChange('whatsapp_number_ids', ids)}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Fade>
          </DialogContent>

          <DialogActions sx={{
            p: 3,
            pt: 2,
            px: 6,
            borderTop: '1px solid',
            borderColor: 'divider',
            gap: 2
          }}>
            <Button
              variant="text"
              startIcon={<Lock />}
              onClick={openResetPassword}
              sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
            >
              Resetar senha
            </Button>
            <Button
              variant="text"
              color="warning"
              startIcon={<Logout />}
              onClick={handleDesconectar}
              disabled={desconectando}
              sx={{ mr: 'auto', borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
            >
              {desconectando ? 'Encerrando...' : 'Desconectar'}
            </Button>
            <Button
              variant="outlined"
              onClick={handleCloseEditModal}
              sx={{ borderRadius: 2, px: 4, py: 1.5, textTransform: 'none', fontWeight: 600 }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveEditOperator}
              sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 4px 14px 0 rgba(0, 118, 255, 0.39)',
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark,
                  boxShadow: '0 6px 20px 0 rgba(0, 118, 255, 0.49)',
                }
              }}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Reset de senha do operador (item 11) */}
        <Dialog open={resetOpen} onClose={() => !resetting && setResetOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Resetar senha {editModalOperator?.name ? `de ${editModalOperator.name}` : ''}</DialogTitle>
          <DialogContent>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
              Defina uma nova senha (mín. 6 caracteres). Informe-a ao operador — ele poderá alterá-la depois.
            </Typography>
            <TextField
              fullWidth
              type="password"
              label="Nova senha"
              value={newPass}
              onChange={({ target }) => setNewPass(target.value)}
              sx={{ mb: 2, mt: 1 }}
              autoFocus
            />
            <TextField
              fullWidth
              type="password"
              label="Confirmar nova senha"
              value={confirmPass}
              onChange={({ target }) => setConfirmPass(target.value)}
              error={Boolean(confirmPass) && confirmPass !== newPass}
              helperText={Boolean(confirmPass) && confirmPass !== newPass ? 'As senhas não conferem.' : ''}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={() => setResetOpen(false)} disabled={resetting} sx={{ textTransform: 'none' }}>Cancelar</Button>
            <Button variant="contained" onClick={handleResetPassword} disabled={resetting} sx={{ textTransform: 'none' }}>
              {resetting ? 'Salvando...' : 'Redefinir senha'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Slide Panel de Filtros */}
        <FilterSlidePanel
          open={filterPanelOpen}
          onClose={handleCloseFilterPanel}
          title="Filtros de Operadores"
          onApply={handleApplyFilters}
          onCancel={handleClearFilters}
          selectedFilter={selectedServiceGroup || selectedStatus !== 'all' ? true : null}
          applyButtonText="Aplicar Filtros"
          cancelButtonText="Limpar Filtros"
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Filtro por Grupo de Serviço */}
            <FormControl fullWidth>
              <InputLabel>Grupo de Serviço</InputLabel>
              <Select
                value={selectedServiceGroup?.id || ''}
                onChange={(e) => {
                  const serviceGroup = props.serviceGroups.find(sg => sg.id === e.target.value);
                  setSelectedServiceGroup(serviceGroup || null);
                }}
                label="Grupo de Serviço"
              >
                <MenuItem value="">
                  <em>Todos os grupos</em>
                </MenuItem>
                {props.serviceGroups.map((serviceGroup) => (
                  <MenuItem key={serviceGroup.id} value={serviceGroup.id}>
                    {serviceGroup.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Filtro por Status */}
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                label="Status"
              >
                <MenuItem value="all">Todos</MenuItem>
                <MenuItem value={1}>Ativo</MenuItem>
                <MenuItem value={4}>Inativo</MenuItem>
              </Select>
            </FormControl>

            {/* Informações dos filtros ativos */}
            {(selectedServiceGroup || selectedStatus !== 'all') && (
              <Box sx={{ 
                p: 2, 
                backgroundColor: theme.palette.primary.light,
                borderRadius: 1,
                color: theme.palette.primary.contrastText
              }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Filtros Ativos:
                </Typography>
                {selectedServiceGroup && (
                  <Typography variant="body2">
                    • Grupo: {selectedServiceGroup.description}
                  </Typography>
                )}
                {selectedStatus !== 'all' && (
                  <Typography variant="body2">
                    • Status: {selectedStatus === 1 ? 'Ativo' : 'Inativo'}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </FilterSlidePanel>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => {
  const { user, serviceGroups, profiles } = state;
  const { currentUser } = user;

  return {
    users: user.users,
    serviceGroups: serviceGroups.serviceGroups,
    profiles,
    currentUser,
    permissions: user.permissions,
  };
};

const mapDispatchToProps = dispatch => ({
  getServiceGroups: () => dispatch(getServiceGroups()),
  getProfiles: () => dispatch(getProfiles()),
  logOut: () => dispatch(logOut()),
  updateUser: data => dispatch(updateUser(data)),
  createUser: data => dispatch(createUser(data)),
  getUsers: (opts) => dispatch(getUsers(opts)),
  updateUserPresence: (userId, status) => dispatch(updateUserPresence(userId, status)),
  fetchTickets: () => dispatch(fetchTickets()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OperatorsPage));
